// TODO: ADSWEB-1523 tokenize gradient

var maskColors = {
  opaque: 'rgba(0,0,0,1)',
  transparent: 'rgba(0,0,0,0)'
};

export { maskColors };
//# sourceMappingURL=gradient.js.map
